import { transformText } from "@/utils/transformText";
import Button from "../Button";
import CustomImage from "../CustomImage";
import Text from "../Text";

type ButtonType = {
  text: string;
  link: string;
};

type CardProps = {
  card: {
    bg: {
      src: {
        desktop: string;
        tablet: string;
        mobile: string;
      };
      alt: string;
    };
    overImageTitle?: string;
    title: string;
    body: string;
    button: ButtonType;
  };
};

const Card = ({ card }: CardProps) => {
  return (
    <div className="card">
      <CustomImage
        src={card.bg.src.desktop}
        srcTablet={card.bg.src.tablet}
        srcMobile={card.bg.src.mobile}
        alt={card.bg.alt}
        className="image"
      />
      <div className="card__holder">
        {card.overImageTitle ? (
          <p className="card__overImageTitle light-gradient">
            {card.overImageTitle}
          </p>
        ) : null}
        <div className="card__content">
          <div className="card__content-holder">
            <div className="card__content-holder-text">
              <Text
                element="h3"
                elementStyle="subtitle"
                className="card__content-title"
              >
                {card.title}
              </Text>
              <Text element="p" elementStyle="body">
                {transformText(card.body, {
                  br: (chunk) => <br />,
                })}
              </Text>
            </div>
            <Button type="primary" isLink isTargetBlank href={card.button.link}>
              {card.button.text}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
